import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(
  () => import("../components/transcript/adminUsers/adminDetails/adminDetails")
);

const TranscriptAdminDetails = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default TranscriptAdminDetails;
